module.exports = __webpack_public_path__ + "img/symbol.8be4c66.svg";